<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import "./assets/css/result.css";
@import "./assets/css/headerfooter.css";
</style>



// WEBPACK FOOTER //
// src/App.vue